import { DashboardPhoneNumbersPanel } from "@/components/dashboard-phone-numbers-panel";

export default function PhoneNumbersPage() {
  return (
    <div className="flex flex-col gap-6 p-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Phone numbers</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Search Twilio inventory, purchase outbound lines, register them with Vapi, and inspect
          Firestore mappings used for regional caller ID.
        </p>
      </div>
      <DashboardPhoneNumbersPanel />
    </div>
  );
}
